import React, { useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import { Helmet } from 'react-helmet';
import {
  InnerBanner,
  BannerDescription,
  BannerHeading,
  BannerP,
  FiguresDetails,
  FSize,
  NumText,
  Num,
} from './styles/InnerPageBanner.styled';
import { Container } from './styles/Container.styled';
import ScrollDownButton from './ScrollDownButton';

export default function BannerWithStats({ data, dir, id }) {
  const { image, title, description, bannerStats } = data;

  useEffect(() => {
    document.body.classList.add('venue-inner-page');
    return () => {
      document.body.classList.remove('venue-inner-page');
    };
  }, []);

  return (
    <>
      {/* <Helmet bodyAttributes={{ class: 'venue-inner-page' }} /> */}
      <InnerBanner className="banner_stats" id={id}>
        {isEmpty(image) || (
          <LazyLoadImage
            width={1920}
            src={image.url}
            alt={image.name}
            className="inner_bnr"
            placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
            effect="blur"
          />
        )}
        <BannerDescription>
          <Container className="container_wrapper">
            <BannerHeading dir={dir}>{title}</BannerHeading>
            <BannerP dir={dir}>{description}</BannerP>
            <FiguresDetails>
              {bannerStats &&
                bannerStats.length > 0 &&
                bannerStats.map(({ content }) => (
                  <FSize dir={dir}>
                    <NumText dir={dir}>{`${content.title} ${content.unit}`}</NumText>
                    <Num dir={dir}>
                      <span dir={dir}>{content.value}</span>
                    </Num>
                  </FSize>
                ))}
            </FiguresDetails>
          </Container>
        </BannerDescription>
        <ScrollDownButton position={data.jumpToSection} />
      </InnerBanner>
    </>
  );
}
